module.exports = __webpack_public_path__ + "img/btn_ios.4482c906.png";